// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-icon[data-v-3e5cfb25] {\n  font-size: 80px;\n  text-align: center;\n  line-height: 100px;\n  width: 100%;\n}\n.text-center[data-v-3e5cfb25] {\n  display: inline-block;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
